import React from 'react';
import { useQuery } from 'react-query';
import { fetchDashboardData } from '../../../api/dashboard';
import { useNavigate } from 'react-router-dom';
import Card from 'components/card';
import SubscriptionInfo from '../profile/SubscriptionInfo';
import PaymentInfo from '../profile/PaymentInfo';
import { MdError } from 'react-icons/md';

const Billing = () => {
  const navigate = useNavigate();
  
  // Check for authentication
  const token = sessionStorage.getItem('token');
  const isAuthenticated = !!token;

  // Use React Query for fetching dashboard data
  const { 
    data: dashboardData, 
    isLoading: isDashboardLoading, 
    error: dashboardError
  } = useQuery('dashboardData', fetchDashboardData, {
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnWindowFocus: false,
    enabled: isAuthenticated, // Only run if authenticated
    retry: 1,
    onError: (err) => {
      console.error("Dashboard data fetch error:", err);
      if (err.message?.toLowerCase().includes('logged in') || 
          err.message?.toLowerCase().includes('unauthorized') ||
          err.response?.status === 401) {
        navigate('/login');
      }
    }
  });

  // Show auth error if not authenticated
  if (!isAuthenticated) {
    return (
      <div className="w-full h-full overflow-x-hidden bg-navy-900">
        <Card extra={"w-full h-full p-4"}>
          <div className="flex flex-col items-center justify-center p-6 text-center">
            <MdError className="text-red-400 text-5xl mb-4" />
            <h3 className="text-xl font-bold text-white mb-2">Authentication Required</h3>
            <p className="text-base text-gray-400 mb-4">Please log in to view your billing information</p>
            <button
              onClick={() => navigate('/login')}
              className="bg-blue-600 px-5 py-3 text-white rounded-lg hover:bg-blue-700"
            >
              Go to Login
            </button>
          </div>
        </Card>
      </div>
    );
  }

  return (
    <div className="w-full h-full overflow-x-hidden bg-navy-900">
      <div className="flex flex-col gap-5 p-5">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-2xl font-bold text-white">Billing Information</h2>
          <div className="flex space-x-2">
            <button
              onClick={() => navigate('/dashboard/profile')}
              className="px-4 py-2 rounded text-white bg-navy-700 hover:bg-navy-600"
            >
              Profile
            </button>
            <button
              className="px-4 py-2 rounded text-white bg-blue-600"
              disabled
            >
              Billing
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-5 xl:grid-cols-2">
          {/* Subscription Info Card */}
          <div className="col-span-1 xl:col-span-1">
            <SubscriptionInfo 
              subscription={dashboardData?.data?.subscription} 
              isLoading={isDashboardLoading} 
              error={dashboardError} 
            />
          </div>

          {/* Payment Info Card */}
          <div className="col-span-1 xl:col-span-1">
            <PaymentInfo 
              invoices={dashboardData?.data?.invoices || []} 
              isLoading={isDashboardLoading} 
              error={dashboardError} 
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Billing;
